// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(action, state) {
  if (typeof state === "number") {
    if (state !== /* FetchingRoles */0) {
      return state;
    }
    if (typeof action === "number") {
      return state;
    }
    if (action.TAG !== /* SetRole */0) {
      return state;
    }
    var roles = action._0;
    switch (roles.TAG | 0) {
      case /* Load */0 :
          return /* FetchingRoles */0;
      case /* OnLoaded */1 :
          var role_opt = roles._0;
          if (role_opt !== undefined) {
            return {
                    TAG: /* FetchingGeoregions */0,
                    _0: role_opt
                  };
          } else {
            return /* NoRole */1;
          }
      case /* LoadErrorView */2 :
          return {
                  TAG: /* ErrorFetchingRoles */3,
                  _0: roles._0
                };
      
    }
  } else {
    switch (state.TAG | 0) {
      case /* FetchingGeoregions */0 :
          if (typeof action === "number") {
            return state;
          }
          if (action.TAG !== /* SetGeoRegions */1) {
            return state;
          }
          var georegions = action._0;
          switch (georegions.TAG | 0) {
            case /* Load */0 :
                return state;
            case /* OnLoaded */1 :
                return {
                        TAG: /* FetchingVehicles */1,
                        _0: state._0,
                        _1: georegions._0
                      };
            case /* LoadErrorView */2 :
                return {
                        TAG: /* ErrorFetchingGeoRegionOrVehicles */4,
                        _0: georegions._0
                      };
            
          }
      case /* FetchingVehicles */1 :
          if (typeof action === "number") {
            return state;
          }
          if (action.TAG !== /* SetVehicles */2) {
            return state;
          }
          var vehicles = action._0;
          switch (vehicles.TAG | 0) {
            case /* Load */0 :
                return state;
            case /* OnLoaded */1 :
                return {
                        TAG: /* FetchingCampaigns */2,
                        _0: state._0,
                        _1: state._1,
                        _2: vehicles._0
                      };
            case /* LoadErrorView */2 :
                return {
                        TAG: /* ErrorFetchingGeoRegionOrVehicles */4,
                        _0: vehicles._0
                      };
            
          }
      case /* FetchingCampaigns */2 :
          var vehicles$1 = state._2;
          var georegions$1 = state._1;
          var roles$1 = state._0;
          if (typeof action === "number") {
            return state;
          }
          if (action.TAG !== /* SetCampaigns */3) {
            return state;
          }
          var campaigns = action._0;
          switch (campaigns.TAG | 0) {
            case /* Load */0 :
                return state;
            case /* OnLoaded */1 :
                return {
                        TAG: /* Dashboard */6,
                        _0: roles$1,
                        _1: georegions$1,
                        _2: vehicles$1,
                        _3: campaigns._0
                      };
            case /* LoadErrorView */2 :
                return {
                        TAG: /* ErrorFetchingCampaigns */5,
                        _0: roles$1,
                        _1: georegions$1,
                        _2: vehicles$1,
                        _3: campaigns._0
                      };
            
          }
      case /* Dashboard */6 :
          if (typeof action === "number") {
            return {
                    TAG: /* FetchingCampaigns */2,
                    _0: state._0,
                    _1: state._1,
                    _2: state._2
                  };
          } else {
            return state;
          }
      default:
        return state;
    }
  }
}

export {
  reducer ,
  
}
/* No side effect */
